import themes from './themes';

const DEFAULT_THEME = 'gl2025';

/**
 *
 * // theme selection parameters
 * @param {import('./styling').ThemeParameters} [parameters]
 * @returns {import('./styling').BackboneTheme}
 */
export default function themeValues(
    {
        selectedTheme = DEFAULT_THEME,
        darkMode = false,

        width,
        height,
        keyboardHeight = 0,
        tablet = false,
        mobile,
        smallMobile = false,

        isIos = false
    } = { width: undefined, height: undefined, mobile: undefined, smallMobile: undefined }
) {
    // if nothing is passed in, we use the "Default Theme"
    // if something is passed in but we don't know that theme, we use the "Default Theme"
    // otherwise we use the requested theme
    const theme = themes[selectedTheme] || themes[DEFAULT_THEME];
    // generate the theme based on the parameters
    return theme.themeValues({
        selectedTheme,
        keyboardHeight,
        height,
        width,
        tablet,
        mobile,
        smallMobile,
        darkMode,
        isIos
    });
}
